// extracted by mini-css-extract-plugin
export default {"lineClam":"TrailItem_lineClam__kodZf","lineClam1":"TrailItem_lineClam1__iI0Wh"};